import palette from './palette';
import colors from './colors';

/**
 * Fills are used in Avatars and Badges.
 */
var fills = {};

fills.solid = {
  neutral: {
    color: 'white',
    backgroundColor: palette.neutral.base
  },
  blue: {
    color: 'white',
    backgroundColor: palette.blue.base
  },
  red: {
    color: 'white',
    backgroundColor: palette.red.base
  },
  orange: {
    color: 'white',
    backgroundColor: palette.orange.base
  },
  yellow: {
    color: palette.yellow.darkest,
    backgroundColor: palette.yellow.base
  },
  green: {
    color: 'white',
    backgroundColor: palette.green.base
  },
  teal: {
    color: 'white',
    backgroundColor: palette.teal.base
  },
  purple: {
    color: 'white',
    backgroundColor: palette.purple.base
  }
};

fills.subtle = {
  neutral: {
    color: colors.text.default,
    backgroundColor: palette.neutral.light
  },
  blue: {
    color: palette.blue.dark,
    backgroundColor: palette.blue.light
  },
  red: {
    color: palette.red.dark,
    backgroundColor: palette.red.light
  },
  orange: {
    color: palette.orange.dark,
    backgroundColor: palette.orange.light
  },
  yellow: {
    color: palette.yellow.dark,
    backgroundColor: palette.yellow.light
  },
  green: {
    color: palette.green.dark,
    backgroundColor: palette.green.light
  },
  teal: {
    color: palette.teal.dark,
    backgroundColor: palette.teal.light
  },
  purple: {
    color: palette.purple.dark,
    backgroundColor: palette.purple.light
  }
};

fills.options = Object.keys(fills.solid);

export default fills;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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